import { CssBaseline } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { Stage, Layer, Image, Line, Rect } from 'react-konva'

const BodyMapCanvas = ({
  drawMarks,
  setDrawMarks,
  lineWidth,
  tool,
  color,
  backgroundImageFile,
  onSave,
  stageRef,
  image,
  setImage,
}) => {
  const [isDrawing, setIsDrawing] = useState(false)

  const handleMouseDown = (e) => {
    setIsDrawing(true)
    const stage = e.target.getStage()
    const position = stage.getPointerPosition()
    setDrawMarks((prevDrawMarks) => [
      ...prevDrawMarks,
      { points: [position.x, position.y], color, lineWidth: lineWidth ?? 5 },
    ])
  }

  const handleMouseMove = (e) => {
    if (!isDrawing) return

    const stage = e.target.getStage()
    const position = stage.getPointerPosition()
    setDrawMarks((prevDrawMarks) => {
      const lastIndex = prevDrawMarks.length - 1
      const updatedMarks = [...prevDrawMarks]
      updatedMarks[lastIndex].points = [
        ...updatedMarks[lastIndex].points,
        position.x,
        position.y,
      ]
      return updatedMarks
    })
  }

  const handleMouseUp = () => {
    setIsDrawing(false)
  }

  useEffect(() => {
    if (backgroundImageFile) {
      // Check if the backgroundImage is an HTMLImageElement
      if (backgroundImageFile instanceof HTMLImageElement) {
        setImage(backgroundImageFile)
      } else {
        // Create a new Image object if not already an HTMLImageElement
        const img = new window.Image()
        img.src = backgroundImageFile
        img.onload = () => {
          setImage(img)
        }
      }
    }
  }, [backgroundImageFile])

  return (
    <div>
      <Stage
        width={500}
        height={500}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onTouchStart={handleMouseDown}
        onTouchMove={handleMouseMove}
        onTouchEnd={handleMouseUp}
        ref={stageRef}
      >
        <Layer>
          {/* Load your body map images here, you can have different images for front, back, head */}
          {/* For simplicity, I'm using a Rect as a placeholder */}
          {image ? (
            <Image width={500} height={500} image={image} />
          ) : (
            <Rect width={500} height={500} fill="#eee" />
          )}

          {/* <Image
            width={500}
            height={500}
            image={document.getElementById('body-map-image')}
          /> */}
        </Layer>

        <Layer>
          {drawMarks.map((line, index) => (
            <Line
              key={index}
              points={line.points}
              stroke={line.color}
              strokeWidth={line.lineWidth} //TODO
              tension={0.5}
            />
          ))}
        </Layer>
      </Stage>
    </div>
  )
}

export default BodyMapCanvas
